/**
 * 市場焦點 Treemap data api
 * @param {String} timePeriod [1day, 1week, 1month, 3month, ytd, 1year]
 * @param {String} country [all, tw, us]
 * @returns
 */
export default function getMartketTrendAPIUrl({ timePeriod, country }) {
  return `/api/v1/market-trend/${country}/${timePeriod}`
}
